'use strict';

var en_CA = require('./en_CA');
var en_US = require('./en_US');
var es_US = require('./es_US');
var fr_CA = require('./fr_CA');

var commonWebLocalization = {
    get: function get(key, lang, country) {
        if (!key || !lang || !country) return null;

        var store = this.getKeyStore(lang, country) || {};
        return store[key] || null;
    },
    updateYearValueToCurrent: function updateYearValueToCurrent(key, lang, country) {
        if (!key || !lang || !country) return null;

        var localizationString = this.get(key, lang, country);

        return localizationString ? localizationString.replace(/(2[0-9]{3})/g, new Date().getFullYear()) : null;
    },
    getKeyStore: function getKeyStore(lang, country) {
        if (!lang || !country) return null;

        var key = lang.toLowerCase() + '_' + country.toUpperCase();
        var keyStore = {
            en_CA: en_CA,
            en_US: en_US,
            es_US: es_US,
            fr_CA: fr_CA
        };

        return keyStore[key];
    }
};

module.exports = commonWebLocalization;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/commonWebLocalization.js
// module id = 107
// module chunks = 0